<template>
  <el-card class="box-card mb-50 user-notice-list">
    <table-notice
      :data="data"
      @change-page="handleChangePage"
      :loading="loading"
      @redirect-detail="redirectDetail"
      :hasCreate="true"
      @handle-redirect-create="redirectCreate">
    </table-notice>
  </el-card>
</template>
<script>
  import { getListUserNotice } from '../../../api/notice'

  export default {
    data() {
      return {
        data: {},
        loading: true,
        sortProp: {key: 'created_at', dir: 'descending'}
      }
    },

    methods: {
      getListData(page=1) {
        getListUserNotice(page, this.sortProp)
        .then(response => response.json())
        .then(response => {
          this.data = response.data;
          this.loading = false;
        })
        .catch((error) => {
        })
      },

      handleChangePage(page) {
        this.loading = true;
        this.getListData(page);
      },

      redirectDetail(id) {
        window.location.href = "/notices/user/" + id;
      },

      redirectCreate() {
        window.location.href = "/notices/user/create";
      }
    },

    created() {
      this.getListData();
    },
  }
</script>
